import { Skeleton } from 'primereact/skeleton';
import classes from './loaderStyle.module.scss';

const NotesSkeletalLoader = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="30rem"></Skeleton>
      </div>
    </div>
  );
};

export default NotesSkeletalLoader;
